import { render } from "./checkbox.vue?vue&type=template&id=6fbc0668"
import script from "./checkbox.vue?vue&type=script&lang=js"
export * from "./checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/form/field/checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fbc0668"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fbc0668', __exports__)) {
    console.log('reload')
    api.reload('6fbc0668', __exports__)
  }
  
  module.hot.accept("./checkbox.vue?vue&type=template&id=6fbc0668", () => {
    console.log('re-render')
    api.rerender('6fbc0668', render)
  })

}


export default __exports__